import axios from "axios";

// initial state
const state = {
  // baseUrl: null,
  // apiUrl: null,
  // logoutUrl: null,
  // adminName: null,
  // isAdmin: null
  // csrfToken: null
  // accessToken: sessionStorage.getItem("access_token") || null
  init: false,
  authenticated: false,
  showLoginModal: false,
  loginModalResolveCallback: null,
  loginModalRejectCallback: null,
};

// getters
const getters = {
  // baseUrl: state => state.baseUrl,
  // apiUrl: state => state.apiUrl,
  // logoutUrl: state => state.logoutUrl,
  // adminName: state => state.adminName,
  // isAdmin: state => state.isAdmin
  // csrfToken: state => state.csrfToken
  // accessToken: state => state.accessToken,
  authenticated: (state) => state.authenticated,
  // hasAccessToken: state => state.authenticated
};

// actions
const actions = {
  // getMyInfo({ commit }) {
  //     return new Promise((resolve, reject) => {
  //         shared_api.getAdminInfo().then(res => {
  //             if (res.data && res.data.data) {
  //                 let data = res.data.data;
  //                 commit("setAdminName", data.name);
  //                 commit("setIsAdmin", data.is_admin);
  //                 resolve();
  //             }
  //         }, reject);
  //     });
  // }
  tryLogin({ commit }, form) {
    return new Promise((resolve, reject) => {
      axios
        .post("/login", form, {
          headers: { __isLoginRequest: true },
        })
        .then((res) => {
          if (res.data && res.data.status && res.data.status == "ok") {
            // commit("setAccessToken", res.data.access_token);
            commit("setAuthenticated", true);
          }
          resolve(res);
        }, reject);
    });
  },
  tryLogout({ commit, dispatch }) {
    return axios.post("/logout").finally(() => {
      commit("setAuthenticated", false);
      dispatch("showLoginModal", { show: true });
    });
  },
  refreshState({ commit }) {
    return axios.get("/login/status").then((res) => {
      if (res.data && res.data.state != undefined) {
        if (res.data.state) {
          commit("setAuthenticated", true);
        } else {
          commit("setAuthenticated", false);
        }
      }
      return res;
    });
  },
  checkInit({ state, dispatch, commit }) {
    if (!state.init) {
      return dispatch("refreshState").then((res) => {
        commit("setInit", true);
      });
    }
    return Promise.resolve();
  },
  showLoginModal(
    { state, dispatch, commit },
    { show, resolve = null, reject = null }
  ) {
    commit("setLoginModalResolveCallback", resolve);
    commit("setLoginModalRejectCallback", reject);
    commit("setShowingLoginModal", show);
  },
};

// mutations
const mutations = {
  setAuthenticated(state, value) {
    state.authenticated = value;
  },
  setInit(state, value) {
    state.init = value;
  },
  setShowingLoginModal(state, value) {
    state.showLoginModal = value;
  },
  setLoginModalResolveCallback(state, value) {
    state.loginModalResolveCallback = value;
  },
  setLoginModalRejectCallback(state, value) {
    state.loginModalRejectCallback = value;
  },
  // setBaseUrl(state, value) {
  //     state.baseUrl = value;
  // },
  // setApiUrl(state, value) {
  //     state.apiUrl = value;
  // },
  // setLogoutUrl(state, value) {
  //     state.logoutUrl = value;
  // },
  // setAdminName(state, value) {
  //     state.adminName = value;
  // },
  // setIsAdmin(state, value) {
  //     state.isAdmin = value;
  // }
  // setCsrfToken(state, value) {
  //     state.csrfToken = value;
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
